<template>
  <div>
    <a class="book-container" :href="href" target="_blank" rel="noreferrer noopener">
      <div class="book">
        <img alt="暂无封面" id="bookImg" :src="src" loading="lazy" @error="imgError"/>
      </div>
    </a>
  </div>
</template>


<script>
export default {
  props: {
    href: String,
    src: String
  },
  methods: {
    imgError(e) {
      e.srcElement.src = require("@/assets/svgs/error.jpg");
    },
  }
};
</script>

<style scoped>
.book-container {
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 600px;
}

@keyframes initAnimation {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(-43deg);
  }
}

.book {
  width: 100px;
  height: 150px;
  position: relative;
  transform-style: preserve-3d;
  transform: rotateY(-43deg);
  transition: 1s ease;
  animation: 1s ease 0s 1 initAnimation;
}

.book-container:hover .book, 
.book-container:focus .book {
  transform: rotateY(0deg);
}

.book > :first-child {
  position: absolute;
  top: 0;
  left: 0;
  background-color: red;
  width: 100px;
  height: 150px;
  transform: translateZ(13.75px);
  background-color: #ffffff;
  border-radius: 0 2px 2px 0;
  box-shadow: 5px 5px 30px #666;
}

.book::before {
  position: absolute;
  content: ' ';
  background-color: blue;
  left: 0;
  top: 1px;
  width: 26px;
  height: 149px;
  transform: translateX(85.7px) rotateY(90deg);
  background: linear-gradient(90deg, 
    #fff 0%,
    #f9f9f9 5%,
    #fff 10%,
    #f9f9f9 15%,
    #fff 20%,
    #f9f9f9 25%,
    #fff 30%,
    #f9f9f9 35%,
    #fff 40%,
    #f9f9f9 45%,
    #fff 50%,
    #f9f9f9 55%,
    #fff 60%,
    #f9f9f9 65%,
    #fff 70%,
    #f9f9f9 75%,
    #fff 80%,
    #f9f9f9 85%,
    #fff 90%,
    #f9f9f9 95%,
    #fff 100%
    );
}

.book::after {
  position: absolute;
  top: 0;
  left: 0;
  content: ' ';
  width: 100px;
  height: 150px;
  transform: translateZ(-13.75px);
  background-color: #01060f;
  border-radius: 0 2px 2px 0;
  box-shadow: -10px 0 50px 10px #666;
}

</style>
